module.exports = __webpack_public_path__ + "img/loadsvg.e7aa2d00.svg";